const HYDRATE = "__NEXT_REDUX_WRAPPER_HYDRATE__";

export const types = {
    GET_CATEGORY_PAGE_DATA_SUCCESS: "PAGE_INFO/GET_CATEGORY_PAGE_DATA_SUCCESS",
};

export const initialState = {
    breadcrumbText: "",
    categoryName: "",
    showDeviceCategoryFilter: "",
    pacCatalogueSearchParams: [],
    stamps: null,
    latestAlgoliaQueryId: null
};

export const actions = {
    getCategoryPageDataSuccess: (data) => ({
        type: types.GET_CATEGORY_PAGE_DATA_SUCCESS,
        payload: data
    }),
};

const PageInfo = (state = initialState, action) => {
    switch (action.type) {
        case HYDRATE: {
            let { pageInfo } = action.payload;
            return {
                ...state,
                ...pageInfo,
            }
        }
        case types.GET_CATEGORY_PAGE_DATA_SUCCESS: {
            const {
                breadcrumbText,
                categoryName,
                showDeviceCategoryFilter,
                pacCatalogueSearchParams,
                stamps
            } = action.payload;

            return {
                ...state,
                breadcrumbText,
                categoryName,
                showDeviceCategoryFilter,
                pacCatalogueSearchParams,
                stamps
            };
        }
        default:
            return state;
    }
};

export default PageInfo;